export default {
	methods: {
		$authed() {
			if (!this.$store.state.authStore) {
				return null;
			}

			return this.$store.state.authStore.authed;
		},

		$impersonator() {
			if (!this.$store.state.authStore) {
				return null;
			}

			return this.$store.state.authStore.impersonator;
		},
	},
};
